import styled from 'styled-components';

export const Hidden = styled.div`
  display: none;
`;

export const CountryWrapper = styled.div`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
`;
